import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from 'admin/common/icons/CloseIcon';
import aibirdeyeIcon from '../../assets/images/aibirdeye.svg';
import './ZoneAiSuggestionsToast.scss';

export default function ZoneAiSuggestionsToast({
  message,
  onClose,
  disabled = false,
  stackIndex = 0,
}) {
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) {
      setVisible(false);
      setMounted(false);
      return undefined;
    }

    setMounted(true);
    const frameId = requestAnimationFrame(() => {
      requestAnimationFrame(() => setVisible(true));
    });

    return () => cancelAnimationFrame(frameId);
  }, [message]);

  const handleTransitionEnd = (event) => {
    if (event.propertyName !== 'transform') return;
    if (!visible) {
      setMounted(false);
    }
  };

  const handleClose = () => {
    if (disabled) return;
    setVisible(false);
    onClose?.();
  };

  if (!mounted || !message) {
    return null;
  }

  return (
    <div
      className={`zone-ai-suggestions-toast${
        visible ? ' zone-ai-suggestions-toast--visible' : ''
      }${disabled ? ' zone-ai-suggestions-toast--disabled' : ''}${
        stackIndex > 0 ? ' zone-ai-suggestions-toast--stacked' : ''
      }`}
      style={{ '--toast-stack-index': stackIndex }}
      role="status"
      aria-live="polite"
      onTransitionEnd={handleTransitionEnd}
    >
      <header className="zone-ai-suggestions-toast__header">
        <div className="zone-ai-suggestions-toast__title">
          <img src={aibirdeyeIcon} alt="" className="zone-ai-suggestions-toast__icon" />
          <span>{t('AI suggestions')}</span>
        </div>
        <button
          type="button"
          className="zone-ai-suggestions-toast__close"
          onClick={handleClose}
          disabled={disabled}
          aria-label={t('Close')}
        >
          <CloseIcon color="#D9D9D9" width="14" height="14" />
        </button>
      </header>
      <p className="zone-ai-suggestions-toast__message">{message}</p>
    </div>
  );
}
